if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this.querySelector(".swiper:not(.swiper-thumbs)");
      this.slides = this.querySelectorAll(".swiper-slide");
      this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.activeIndex = 0;
      this.initialized = false;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector('.swiper-thumbs');
      }
      if (this.dataset.customEvent) {
        this.attachCustomListeners(this.dataset.customEvent);
      }
      if (this.slideContainer && this.slides.length > 0) {
        document.addEventListener(
          "DOMContentLoaded",
          this.initializeSwiper.bind(this)
        );
        document.addEventListener(
          "shopify:section:load",
          this.initializeSwiper.bind(this)
        );
        window.addEventListener("resize", this.handleResize.bind(this));
      } else {
        console.warn("SwiperSlider - Slider or Slides Not Found");
      }
    }
    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "cart_updated":
          document.addEventListener("cart_updated", this.updateSlides.bind(this));
          break;
      }
    }
    updateSlides(event) {
      const recommendationId = event.detail.recommendation;
      const matchingSlides = this.querySelectorAll(
        `.add-on--${recommendationId}`
      );
      matchingSlides.forEach((slide) => {
        try {
          this.slider.removeSlide(slide.dataset.swiperSlideIndex);
        } catch (err) {
          document.querySelector(
            ".mini-cart_footer .recommendation_header"
          ).style.display = "none";
          this.style.display = "none";
        }
      });
    }
    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      options.speed = 400;
      return options;
    }

    getSliderOptions() {
      try {
        return JSON.parse(this.dataset.swiperOptions);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        if(this.thumbnails) {
          this.setThumbnails()
        }
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSliderEventListeners();
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = {swiper: thumbnailsSlider};
      this.sliderOptions.on = {
      	slideChange: function () {
          const activeIndex = this.activeIndex;
          document.dispatchEvent(new CustomEvent('thumbnail-changed', {
            detail: {
              slide: this.slides[this.activeIndex]
            }
          }))
         // this.thumbs.swiper.slideTo(activeIndex > 0 ? activeIndex - 1: 0);    
        }
      }
    }

    initializeSliderEventListeners() {}
  }
  customElements.define("swiper-slider", SwiperSlider);
  
  class SwiperTabSlider extends SwiperSlider {
    constructor() {
      super();
      this.tabs = this.querySelectorAll(".glide__nav-item");
      if (this.tabs.length > 0) {
        this.tabs.forEach((tab) => {
          tab.addEventListener("click", this.goToSlide.bind(this, tab));
        });
      }
    }
    goToSlide(tab) {
      try {
        const tabIndex = tab.dataset.newIndex;
        if (tabIndex) {
          this.slider.slideTo(tabIndex);
        } else {
          console.warn("newIndex not provided for Tab Slider Tab");
        }
      } catch (err) {
        console.warn(err);
      }
    }
  }
  customElements.define("swiper-tab-slider", SwiperTabSlider);
}